import { IAppState } from "../app.state";

export const selectQuotation = (state: IAppState) => state.quotation;